import api from '../src/services/labourPalnningService';
import moment from 'moment';
import { EventBus } from '../src/eventBus';
export const monthlyScheduleMixin = {
    data() {
        return {
            secondaryStoreShiftsData: [],
            loanedInStoreShiftsData: [],
            secondaryStoreEmpData: [],
            loanedInStoreEmpData: [],
            secondaryStoreCustomShifts: [],
            formatted_secondaryStore_data: [],
            formatted_loanedInStore_data: [],
            all_cluster_store_list: [],
            all_ss_emp_list: [],
        }
    },
    computed: {
        combinedSecondaryStoreShiftsData() {
            let result = [];
            const shiftData = JSON.parse(JSON.stringify(this.secondaryStoreShiftsData));
            for (const key in shiftData) {
                if (Object.hasOwnProperty.call(shiftData, key)) {
                    const element = shiftData[key];
                    // element.forEach((e) => {
                    //     result.push(e);
                    // });
                    result.push(...element);
                }
            }
            return result;
        }
    },
    methods: {
        deleteShiftByDate(date){
            if(!date){ return; }
            let data = {
                outlet_id: this.selected_store,
                dates: [date]
            }
            this.$confirm('Are you sure you want to delete all shifts for this date ?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                api.deleteShiftByDate(data).then((response) => {
                    EventBus.$emit('updatePrimaryStoreData', true);
                }).catch((error) => {
                    console.log(error);
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Shift deletion cancelled'
                });          
            });
        },
        getSecondaryStoreScheduleData(obj) {
            let data = {
                outlet_id: obj.storeID,
                start_date: obj.formDate,
                end_date: obj.toDate,
                get_all: true
            }
            api.getShiftDataForSecondaryStore(data).then((response) => {
                this.secondaryStoreShiftsData = JSON.parse(response.data);
            }).catch((error) => {
                console.log(error);
            });
        },
        getLoanedInStoreScheduleData(obj) {
            let data = {
                outlet_id: obj.storeID,
                start_date: obj.formDate,
                end_date: obj.toDate,
                get_all: true,
                check_for_secondary: true
            }
            api.getShiftDataForSecondaryStore(data).then((response) => {
                this.loanedInStoreShiftsData = JSON.parse(response.data);
            }).catch((error) => {
                console.log(error);
            });
        },
        getSecondaryStoreEmpData(obj) {
            let data = {
                outlet_id: obj.storeID
            }
            api.getEmployeeListForSecondaryStore(data).then((response) => {
                this.secondaryStoreEmpData = JSON.parse(response.data);
            }).catch((error) => {
                console.log(error);
            });
        },
        getLoanedInStoreEmpData(obj) {
            let data = {
                outlet_id: obj.storeID,
                check_for_secondary: true
            }
            api.getEmployeeListForSecondaryStore(data).then((response) => {
                this.loanedInStoreEmpData = JSON.parse(response.data);
            }).catch((error) => {
                console.log(error);
            });
        },
        getSecondaryStoreCustomShifts(obj) {
            let data = {
                outlet_id: obj.storeID
            }
            api.getCustomShiftsForSecondaryStore(data).then((response) => {
                this.secondaryStoreCustomShifts = JSON.parse(response.data);
            }).catch((error) => {
                console.log(error);
            });
        },
        getSecondaryStoreScheduleDataAll(obj) {
            this.getLoanedInStoreScheduleData(obj);
            this.getLoanedInStoreEmpData(obj);
            let data1 = {
                outlet_id: obj.storeID,
                start_date: obj.formDate,
                end_date: obj.toDate,
                get_all: true
            };
        
            let data2 = {
                outlet_id: obj.storeID
            };
        
            let data3 = {
                outlet_id: obj.storeID
            };
        
            Promise.all([
                api.getAllStoreDataCluster(),
                api.getEmployeeListForSecondaryStore(data2),
                api.getShiftDataForSecondaryStore(data1),
                api.getCustomShiftsForSecondaryStore(data3)
            ]).then((responses) => {
                this.all_cluster_store_list = JSON.parse(responses[0].data);
                this.secondaryStoreEmpData = JSON.parse(responses[1].data);
                this.secondaryStoreShiftsData = JSON.parse(responses[2].data);
                this.secondaryStoreCustomShifts = JSON.parse(responses[3].data);
                this.formatDataSecondaryStoreData();
                this.formatDataLoanedInStoreData();
                // pass all emp list in all_ss_emp_list
                for (const key in this.secondaryStoreEmpData) {
                    if (Object.hasOwnProperty.call(this.secondaryStoreEmpData, key)) {
                        const element = this.secondaryStoreEmpData[key];
                        element.forEach((e) => {
                            this.all_ss_emp_list.push(e);
                        });
                    }
                }
            }).catch((error) => {
                console.log(error);
            });
        },        
        formatDataSecondaryStoreData(){
            let result = [];
            const days = JSON.parse(JSON.stringify(this.dayListOfMonth));
            let secondaryStoreShifts = JSON.parse(JSON.stringify(this.secondaryStoreShiftsData));
            let sData = JSON.parse(JSON.stringify(this.secondaryStoreCustomShifts));
            // Add necessary keys to each day
            days.forEach((dd) => {
                dd.against_deficit = null;
                dd.against_shift = null;
                dd.is_excess = null;
                dd.week_off_assigned = null;
                dd.date = dd.formatDate;
                dd.is_disabled = false;
            });
            // Format all secondary store data
            for (const key in this.secondaryStoreEmpData) {
                const getStoreDetails = this.all_cluster_store_list.find(x => x.id == key);
                result.push({
                    store_id: key,
                    store_name: getStoreDetails ? getStoreDetails.name : '-',
                    emp_data: this.secondaryStoreEmpData[key],
                    custom_shifts: this.secondaryStoreCustomShifts.filter(x => x.store == key),
                });
            }

            // Add shift data to each day
            let shift_arr = [];
            result.map((store) => {
                store.emp_data.map((emp) => {
                    let sec_shifts_data = [];
                    let all_sec_shift_data = [];
                    let dd = secondaryStoreShifts[store.store_id];
                    let ss = dd ? dd.filter(x => x.employee == emp.id) : [];
                    sec_shifts_data = ss;
                    let allShifts = _.unionBy(sec_shifts_data, days, 'date');
                    all_sec_shift_data = _.sortBy(allShifts, ['date']);
                    shift_arr.push({shifts: all_sec_shift_data, store_id: store.store_id, emp_id: emp.id});
                });
                // console.log('Store wise debugging:', store); // Debugging
            });

            //  we need to maintain thi separately 
            this.formatSecondarySHiftDataRes(result, shift_arr, sData);
        },

        formatDataLoanedInStoreData(){
            let result = [];
            const days = JSON.parse(JSON.stringify(this.dayListOfMonth));
            let secondaryStoreShifts = JSON.parse(JSON.stringify(this.loanedInStoreShiftsData));
            let ssData = JSON.parse(JSON.stringify(this.secondaryStoreCustomShifts));
            let psData = JSON.parse(JSON.stringify(this.all_custom_shifts));
            console.log(psData, 'psData')
            let sData = [...ssData, ...psData];
            console.log(secondaryStoreShifts, 'Shift data for loaned in store')
            // Add necessary keys to each day
            days.forEach((dd) => {
                dd.against_deficit = null;
                dd.against_shift = null;
                dd.is_excess = null;
                dd.week_off_assigned = null;
                dd.date = dd.formatDate;
                dd.is_disabled = false;
            });
            // Format all secondary store data
            for (const key in this.loanedInStoreEmpData) {
                const getStoreDetails = this.all_cluster_store_list.find(x => x.id == key);
                result.push({
                    store_id: key,
                    store_name: getStoreDetails ? getStoreDetails.name : '-',
                    emp_data: this.loanedInStoreEmpData[key],
                    custom_shifts: this.secondaryStoreCustomShifts.filter(x => x.store == key),
                });
            }

            // Add shift data to each day
            let shift_arr = [];
            result.map((store) => {
                store.emp_data.map((emp) => {
                    let sec_shifts_data = [];
                    let all_sec_shift_data = [];
                    let dd = secondaryStoreShifts[this.selected_store];
                    console.log(dd,store.store_id, 'dddd This is the shift data for loaned in store')
                    let ss = dd ? dd.filter(x => x.employee == emp.id) : [];
                    sec_shifts_data = ss;
                    let allShifts = _.unionBy(sec_shifts_data, days, 'date');
                    all_sec_shift_data = _.sortBy(allShifts, ['date']);
                    shift_arr.push({shifts: all_sec_shift_data, store_id: store.store_id, emp_id: emp.id});
                });
                // console.log('Store wise debugging:', store); // Debugging
            });
            console.log(result, shift_arr, sData, 'This is the result of the loaned in store data')
            //  we need to maintain thi separately 
            this.formatSecondaryLIShiftDataRes(result, shift_arr, sData);
        },

        getStoreName(store_id) {
            const selected_store = this.all_store_list.find(x => x.id == store_id);
            return selected_store ? selected_store.name : '-';
        },

        formatSecondarySHiftDataRes(result, shift_arr, sData){
            let temp = JSON.parse(JSON.stringify(result));
            temp.forEach((r)=>{
                r.emp_data.forEach((e)=>{
                    const sss = shift_arr.find(sd=> sd.emp_id == e.id && sd.store_id == r.store_id);
                    e.all_sec_shift_data = sss.shifts;
                    // console.log('This is employee id from emp data' ,e.id, 'This is employee id from shift data', sss.emp_id, 'This is store id', sss.store_id)
                })
            });

            temp.forEach((store) => {
                store.emp_data.forEach((r) => {
                    // console.log(r, 'Debugging after the all loop end in rrrrrrrrrr')
                    r.all_sec_shift_data.forEach((s) => {
                        // console.log(s,store.store_id, store.emp_data, 'aaaa')
                        if (s.assigned_shift) {
                            // console.log(s,store.store_id, store.emp_data, 'aaaas')
                            // const shiftNameData = store.custom_shifts.find((sd) => sd.id == s.assigned_shift);
                            const shiftNameData = sData.find((sd) => sd.id == s.assigned_shift);
                            s.shift_name = shiftNameData ? shiftNameData.name : '-';
                            s.toggle_dropdown = false;
                        } else if(s.week_off_assigned) {
                            s.shift_name = 'OFF';
                        } else if(s.leave_assigned) {
                            s.shift_name = 'L';
                        }
                    });
                });
            });

            this.formatted_secondaryStore_data = temp;
            this.$forceUpdate();
        },
        formatSecondaryLIShiftDataRes(result, shift_arr, sData){
            let temp = JSON.parse(JSON.stringify(result));
            temp.forEach((r)=>{
                r.emp_data.forEach((e)=>{
                    const sss = shift_arr.find(sd=> sd.emp_id == e.id && sd.store_id == r.store_id);
                    e.all_sec_shift_data = sss.shifts;
                    // console.log('This is employee id from emp data' ,e.id, 'This is employee id from shift data', sss.emp_id, 'This is store id', sss.store_id)
                })
            });

            temp.forEach((store) => {
                store.emp_data.forEach((r) => {
                    // console.log(r, 'Debugging after the all loop end in rrrrrrrrrr')
                    r.all_sec_shift_data.forEach((s) => {
                        // console.log(s,store.store_id, store.emp_data, 'aaaa')
                        if (s.assigned_shift) {
                            // console.log(s,store.store_id, store.emp_data, 'aaaas')
                            // const shiftNameData = store.custom_shifts.find((sd) => sd.id == s.assigned_shift);
                            const shiftNameData = sData.find((sd) => sd.id == s.assigned_shift);
                            s.shift_name = shiftNameData ? shiftNameData.name : '-';
                            s.toggle_dropdown = false;
                        } else if(s.week_off_assigned) {
                            s.shift_name = 'OFF';
                        } else if(s.leave_assigned) {
                            s.shift_name = 'L';
                        }
                    });
                });
            });

            this.formatted_loanedInStore_data = temp;
            this.$forceUpdate();
        },
        
    }
}